import { type NodeRenderer } from '@contentful/rich-text-react-renderer'
import { Hyperlink } from '@ui/hyperlink'
import React from 'react'

export const hyperlink: NodeRenderer = (node, children) => (
  <Hyperlink href={node.data.uri}>{children}</Hyperlink>
)
